class Logger {
    isClient = typeof window !== 'undefined'
    isServer = typeof window === 'undefined'
    isDev = typeof window === 'undefined' && process.env.NODE_ENV === 'development'
    isProd = typeof window === 'undefined' && process.env.NODE_ENV === 'production'

    log(message?: unknown, ...optionalParams: unknown[]): void {
        console.log(message, ...optionalParams)
    }

    error(message?: unknown, ...optionalParams: unknown[]): void {
        console.error(message, ...optionalParams)
    }

    dev(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.isProd) return
        console.log(message, ...optionalParams)
    }

    server(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.isClient) return
        console.log(message, ...optionalParams)
    }

    serverError(message?: unknown, ...optionalParams: unknown[]): void {
        if (this.isClient) return
        console.error(message, ...optionalParams)
    }
}

export default new Logger()
